import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { patchExpressionParameter } from 'Services';
import { RQ_PARAMETERS, RQ_UPDATE_EXPRESSION_PARAMETER } from 'Utils';

type Options = {
    mutationOptions: UseMutationOptions<AxiosResponse<Parameter>, unknown, PatchParameterRequest, unknown>;
};

function usePatchExpressionParameter({ mutationOptions }: Options) {
    const queryClient = useQueryClient();

    return useMutation([RQ_UPDATE_EXPRESSION_PARAMETER], patchExpressionParameter, {
        onSuccess: (data, variables, context) => {
            mutationOptions.onSuccess?.(data, variables, context);
            queryClient.invalidateQueries([RQ_PARAMETERS]);
        },
        onError: mutationOptions.onError
    });
}

export default usePatchExpressionParameter;
